<template>
  <Bar
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :css-classes="cssClasses"
    :styles="styles"
    :width="200"
    :height="myheight"
  />
</template>

<script>
import { Bar } from 'vue-chartjs'
export default {
  name: 'BarChart',
  components: { Bar },
  props: {
    chartId: {
      type: String,
      default: 'bar-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 200
    },
    height: {
      type: Number,
      default: 100
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    myheight() {
      if(window.innerWidth>1024){
        return this.height;
      } else if(window.innerWidth>768){
        return 100;
      } else {
        return '';
      }
    }
  },
  mounted() {
    //console.log('chart bars component mounted');
  },
  created() {
    //console.log('chart bars component created');
  },
  unmounted: function() {
    //console.log('chart bars component destroyed');
  },
  data() {
    return {
      chartData: {
        labels: ["2016", "2017", "2018", "2019", "2020", "2021"],
        datasets: [
          {
            type: "bar",
            //label: "Millones de Euros",
            data: [1707, 1799, 1775, 1861, 1684, 2053],
            backgroundColor: [
              "#023e5f",
              "#0E71B8",
              "#B8B30E",
              "#F7A715",
              "#B94017",
              "#B8559A"
            ]
          }
        ]
      },
      chartOptions: {
        language: this.$i18n.locale,
        showAllTooltips: true,
        responsive: true,
        categoryPercentage: 1.0,
        barPercentage: 0.05,
        animation: {
          duration: 2000,
        },
        scales: {
          x: {
            grid: {
              display: false
            },
            ticks: {
                font: {
                    size: 16,
                    weight: 700,
                    family: '"Gotham Light","Montserrat", Helvetica, Arial, sans-serif'
                },
                color: '#000000'
            }
          },
          y: {
            ticks: {
                font: {
                  size: 16,
                    weight: 700,
                    family: '"Gotham Light","Montserrat", Helvetica, Arial, sans-serif'
                },
                color: '#000000',
                callback: function(value) {
                  if(this.$context.chart.options.language=='es'){
                    return value.toLocaleString().replace(',','.')
                  } else {
                    return value.toLocaleString().replace('.',',')
                  }
                }
            },
             min: 1400,
                suggestedMin: 1400,
                max: 2100,
                suggestedMax: 2100
          }

        },
        layout: {
          padding: {
            top: 30
          }
        },
        plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              enabled: true
            },
            datalabels: {
              color: 'black',
              textAlign: 'center',
              anchor: 'end',
              align: 'top',
              offset: 5,
              font: {
                  weight: "bold",
                  size: 18,
                  family: '"Gotham Light","Montserrat", Helvetica, Arial, sans-serif'
              },
              formatter: function(value, context) {
                  if(context.chart.options.language=='es'){
                    return value.toLocaleString().replace(',','.')
                  } else {
                    return value.toLocaleString().replace('.',',')
                  }
              },
          },
        }
      }
    }
  }
}
</script>
